// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf } from "@altostra/type-validations";
import { string, boolean, number, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isFilterType = objectOf({
  filter_key: string,
  display_name: string,
  varies_by_app_group: boolean,
  allowed_for_territories: boolean,
  only_for_workflow_step: boolean,
  allowed_for_predictions: boolean,
  additional_filter_data: objectOf({}),
  value: string,
  comparison_key: string,
  filters: arrayOf(
    objectOf({
      filter_key: string,
      display_name: string,
      varies_by_app_group: boolean,
      allowed_for_territories: boolean,
      only_for_workflow_step: boolean,
      allowed_for_predictions: boolean,
      additional_filter_data: objectOf({}),
      value: objectOf({
        id: string,
        value: string,
      }),
      comparison_key: string,
    })
  ),
});

export const isSegmentFilterType = objectOf({
  filter_key: string,
  display_name: string,
  varies_by_app_group: boolean,
  allowed_for_territories: boolean,
  only_for_workflow_step: boolean,
  allowed_for_predictions: boolean,
  additional_filter_data: objectOf({}),
  valid_comparisons_dictionary: anyOf(
    objectOf({
      "1": string,
      "2": string,
    }),
    objectOf({})
  ),
  grouped_comparisons: nullOrUndefined,
  valid_values: anyOf(string, arrayOf(string)),
  default_value: anyOf(string, nullOrUndefined),
  default_comparison: anyOf(string, nullOrUndefined),
  is_remote: boolean,
  remote_value_count: number,
  requires_values: boolean,
  valid_values_restricted_for_look_back: boolean,
  data_type: nullOrUndefined,
});

export const isSegmentResult = objectOf({
  id: string,
  app_group_id: string,
  app_ids: arrayOf(string),
  name: string,
  description: string,
  is_archived: boolean,
  filters: objectOf({}),
  created_at: number,
  updated_at: number,
  updated_by: string,
  enable_analytics_tracking: boolean,
  api_identifier: string,
  tag_names: arrayOf(string),
  territory_ids: arrayOf(string),
  changelog_count: number,
  include_all_apps: boolean,
  include_users_without_app: boolean,
  campaigns_using_segment: anyOf(
    nullOrUndefined,
    objectOf({
      count: number,
      data: arrayOf(string),
    })
  ),
  cards_using_segment: anyOf(
    nullOrUndefined,
    objectOf({
      count: number,
      data: arrayOf(string),
    })
  ),
  workflows_using_segment: anyOf(
    nullOrUndefined,
    objectOf({
      count: number,
      data: arrayOf(string),
    })
  ),
  segments_using_segment: anyOf(
    nullOrUndefined,
    objectOf({
      count: number,
      data: arrayOf(string),
    })
  ),
});

export const isEngagementSegmentDataResult = objectOf({
  segment: isSegmentResult,
  prevent_more_analytics: boolean,
  segment_filter_types: arrayOf(isSegmentFilterType),
});
